import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=e482bfa2&scoped=true&"
import script from "./AddressInput.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./AddressInput.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=e482bfa2&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e482bfa2",
  null
  
)

export default component.exports